import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import LekovyZaznamList from './LekovyZaznamList';

loadDOMComponent({
	selector: 'react-lekovy-zaznam-list',
	callback: ({ container }) => {
		ReactDOM.render(
			<AppContextProvider>
				<LekovyZaznamList />
			</AppContextProvider>,
			container,
		);
	},
});
